import { module } from 'modujs';
import { whenReady } from "../utils/fonts";
import { $screenDebounce } from "../stores/screen.js";
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { $html } from '../utils/dom.js';
import { CSS_CLASS, ENV, FONT } from '../config.js';
gsap.registerPlugin(SplitText)

export default class extends module {
    constructor(m) {
        super(m);

        // Options
        this.delay = parseFloat(this.getData('delay')) || 0.0;
        this.stagger = parseFloat(this.getData('stagger')) || 0.15;
    }

    ///////////////
    // Lifecycle
    ///////////////
    init() {
        this.bindEvents()
        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts));
    }

    destroy() {
        super.destroy();
        this.unbindEvents()
    }


    ///////////////
    // Events
    ///////////////
    unbindEvents() {
        this.unbindScreenListener?.()
    }

    bindEvents() {
        this.unbindScreenListener = $screenDebounce.listen(this.onResize);
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize = () => {
        this.reSplit()
    }

    onFontsLoaded(fonts) {
        this.reSplit()
    }

    ///////////////
    // Methods
    ///////////////
    split() {
        if(ENV.PREFERS_REDUCED_MOTION) return

        if($html.classList.contains(CSS_CLASS.REPLACING_FRAGMENT) && this.el.classList.contains('-ignore-fragment')) return

        this.splitObject = new SplitText(this.el, {
            type: "lines",
            tag: "span"
        });
        this.splitObject.lines.forEach((line, i) => {
            line.style.transitionDelay = `${this.delay + (i * this.stagger)}s`
        });
    }

    reSplit() {
        this.splitObject?.revert?.();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.split();
            })
        })
    }
}
